module.exports = __webpack_public_path__ + "img/poza_default1.ec9418b8.jpg";